import type { ReactNode } from "react";
import { renderLinkifiedText } from "./waveLinkify";

const MENTION_INLINE_RE = /@([\p{L}\p{N}._-]+)/gu;

/** Comment/chat body: https links + styled @mentions (no todo markdown). */
export function renderMentionAwareText(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  MENTION_INLINE_RE.lastIndex = 0;
  let last = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = MENTION_INLINE_RE.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(...renderLinkifiedText(text.slice(last, match.index)));
    }
    parts.push(
      <span key={key++} className="wave-todo-mention-inline">
        @{match[1]}
      </span>,
    );
    last = MENTION_INLINE_RE.lastIndex;
  }

  if (last < text.length) {
    parts.push(...renderLinkifiedText(text.slice(last)));
  }

  return parts.length ? parts : renderLinkifiedText(text);
}
